import { render, staticRenderFns } from "./t-breadcrumbs.vue?vue&type=template&id=545ea329"
import script from "./t-breadcrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-breadcrumbs.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports